import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import withNotify from '../../common/withNotify';
import { renderField } from '../../helpers/form-validations';

class MrnOrPatientIdModal extends Component {
  render() {
    const { handleSubmit, onSubmit } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="mrnOrPatientIdModal"
        tabIndex="-1"
        aria-labelledby="mrnOrPatientIdModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)} form="mrnPatientIdForm">
              <div className="modal-body">
                <h5 className="modal-title" id="cancelCaseModalLabel">Add one of the following:</h5>
                <div>
                  <Field
                    type="text"
                    name="patientId"
                    className="form-control text-uppercase search-input-focus search-input"
                    placeholder="Patient ID"
                    component={renderField}
                    onKeyDown={(evt) => ['\'', '%', '#', '*'].includes(evt.key) && evt.preventDefault()}
                  />
                  <br />
                  <Field
                    type="text"
                    name="mrn"
                    className="form-control text-uppercase search-input-focus search-input"
                    placeholder="MRN #"
                    component={renderField}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <div className="row gx-2 button-wrap">
                  <div className="col-6">
                    <button
                      type="button" className="btn btn-link btn-left w-100"
                      data-bs-dismiss="modal"
                    >Back
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="submit"
                      className="btn btn-link w-100"
                      data-bs-dismiss="modal"
                    >Next
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'mrnPatientIdForm',
});

export default withNotify(withTableName(withLoader(withOnline(withForm(MrnOrPatientIdModal)))));
